/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.rest.route

object RootPath {
    /*
     * The fragment isn't used directly in the URL, because the application will also grab other query string arguments
     * and set them aside, then perform a redirect to the fragment to that the URL bar doesn't show all of the
     * query string arguments.  Example: Password requires deep linking with the token as an argument, and this
     * ensures the app can clear the token from the address bar very quickly.
     */

    /**
     * An optional query string argument for a fragment, which the app will attempt to redirect to upon page load.
     */
    const val QUERY_STRING_KEY_DEEP_LINK_FRAGMENT = "deep_link_fragment"
}
